"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorChartModalButtonWrapp = exports.ColorChartModalCircle = exports.ColorChartModalLinksWrap = exports.ColorChartModalLinksItem = exports.ColorChartModalLinks = exports.ColorChartModalStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _modal = require("@dbi-tools/ui-kit/lib/modal");

var _icon = require("@dbi-tools/ui-kit/lib/icon");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  &:not(:last-of-type) {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n  div {\n    min-width: 40px;\n  }\n  span {\n    font-size: 32px;\n    line-height: 40px;\n    color: ", ";\n    font-weight: ", ";\n  }\n  ", " {\n    margin-top: 0;\n    div {\n      min-width: 36px;\n    }\n    span {\n      font-size: 24px;\n      line-height: 36px;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 30px;\n  border-left: 1px solid ", ";\n  ", " {\n    margin-top: 30px;\n    padding-left: 0;\n    border: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 25%;\n  padding: 0 7.5px;\n  a {\n    font-size: ", ";\n    margin-top: 15px;\n    text-transform: inherit;\n    font-weight: ", ";\n    padding-bottom: 0 !important;\n    text-align: left;\n    letter-spacing: inherit;\n  }\n  ", " {\n    width: 33.33%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -7.5px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    opacity: 0;\n  }\n  ", " {\n    padding: 50px;\n    ", " {\n      display: flex;\n      align-items: flex-end;\n      padding: 50px 0 0;\n      overflow: hidden;\n    }\n  }\n  ", " {\n    max-width: 900px;\n  }\n  ", " {\n    padding-left: 60px;\n\n    ", " {\n      padding: 24px 70px 24px 24px;\n    }\n    button {\n      padding: 30px;\n      ", " {\n        padding: 20px;\n      }\n      ", " * {\n        fill: ", ";\n      }\n      &:hover,\n      &:focus {\n        ", " * {\n          fill: ", ";\n        }\n      }\n    }\n  }\n  ", " {\n    padding: 15px 60px 60px;\n    margin-bottom: 0;\n    border-bottom: 1px solid transparent;\n    max-height: 80vh;\n    overflow: auto;\n    ", " {\n      padding: 0 24px 24px;\n    }\n  }\n  ", " {\n    &.is-rendered {\n      opacity: 1;\n      ", " {\n        top: 100vh;\n        transition: top 0.4s;\n      }\n    }\n    &.is-open {\n      ", " {\n        top: 0;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ColorChartModalStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), _uiKit.GridBreakpointsMediaDown.md, _modal.ModalWrapperStyled, _uiKit.GridBreakpointsMediaDown.md, _modal.Dialog, _modal.ModalHeaderStyled, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.md, _icon.IconStyled, _uiKit.Colors.gray800, _icon.IconStyled, _uiKit.Colors.gray800, _modal.ModalBodyStyled, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.md, _modal.Dialog, _modal.Dialog);
exports.ColorChartModalStyled = ColorChartModalStyled;
var ColorChartModalLinks = (0, _uiKit.styled)('div')(_templateObject2());
exports.ColorChartModalLinks = ColorChartModalLinks;
var ColorChartModalLinksItem = (0, _uiKit.styled)('div')(_templateObject3(), _uiKit.TextSize.xs, _uiKit.FontWeightValue.thin, _uiKit.GridBreakpointsMediaDown.md);
exports.ColorChartModalLinksItem = ColorChartModalLinksItem;
var ColorChartModalLinksWrap = (0, _uiKit.styled)('div')(_templateObject4(), _uiKit.Colors.platinum, _uiKit.GridBreakpointsMediaDown.md);
exports.ColorChartModalLinksWrap = ColorChartModalLinksWrap;
var ColorChartModalCircle = (0, _uiKit.styled)(_uiKit.Box)(_templateObject5(), _uiKit.Colors.gray800, _uiKit.FontWeightValue.bold, _uiKit.GridBreakpointsMediaDown.md);
exports.ColorChartModalCircle = ColorChartModalCircle;
var ColorChartModalButtonWrapp = (0, _uiKit.styled)("div")(_templateObject6());
exports.ColorChartModalButtonWrapp = ColorChartModalButtonWrapp;